import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { t } from "../../../../../services";
import { strCode } from "../../../../../consts";

import {
  CircleIconButton,
  FlexContainers,
  PageSelector,
  SVG,
  WrapperContainer
} from "../../../../../components";
import PropTypes from "prop-types";
import { FeaturesHintWrapper } from "../styled";
import { PageSelectorWrapper } from "./styled";
import FeaturesSectionList from "./FeaturesSectionList";

const featureTypes = {
  ACTIVATED: "activated",
  DEACTIVATED: "deactivated",
  CUSTOM: "custom"
};

const FeaturesList = ({ onModalOpen }) => {
  const [activeSection, setActiveSection] = useState(featureTypes.ACTIVATED);

  const features = useSelector((store) => store.apps.selectedApp.defaultSettings || []);
  const customFeatures = useSelector((store) => store.apps.selectedApp.customFeatures || []);

  const activatedFeatures = features.filter((feature) => feature?.value);
  const deactivatedFeatures = features.filter((feature) => !feature?.value);

  const featureSections = [
    {
      id: featureTypes.ACTIVATED,
      title: strCode.ACTIVATED_TITLE,
      disabled: !activatedFeatures?.length
    },
    {
      id: featureTypes.DEACTIVATED,
      title: strCode.DEACTIVATED_TITLE,
      disabled: !deactivatedFeatures?.length
    },
    { id: featureTypes.CUSTOM, title: strCode.CUSTOM_TITLE, disabled: !customFeatures?.length }
  ];

  useEffect(() => {
    if (!activatedFeatures?.length && (deactivatedFeatures?.length || customFeatures?.length)) {
      setActiveSection(
        deactivatedFeatures?.length ? featureTypes.DEACTIVATED : featureTypes.CUSTOM
      );
    }
  }, [activatedFeatures?.length, deactivatedFeatures?.length, customFeatures?.length]);

  return (
    <>
      {features.length > 0 || customFeatures?.length > 0 ? (
        <>
          <PageSelectorWrapper
            Container={FlexContainers.FlexRowStart}
            width={"fit-content"}
            pb={24}>
            <PageSelector
              pages={featureSections}
              activePage={activeSection}
              setActivePage={setActiveSection}
            />
          </PageSelectorWrapper>

          <WrapperContainer width="100%">
            <WrapperContainer
              Container={FlexContainers.FlexColumnStart}
              gap={16}
              pl={5}
              alignItems="start">
              {activeSection === featureTypes.ACTIVATED && activatedFeatures?.length > 0 && (
                <FeaturesSectionList features={activatedFeatures} />
              )}

              {activeSection === featureTypes.DEACTIVATED && deactivatedFeatures?.length > 0 && (
                <FeaturesSectionList features={deactivatedFeatures} />
              )}

              {activeSection === featureTypes.CUSTOM && customFeatures?.length > 0 && (
                <FeaturesSectionList features={customFeatures} />
              )}
            </WrapperContainer>
          </WrapperContainer>
        </>
      ) : (
        <WrapperContainer Container={FlexContainers.FlexColumnCenter} width="100%" mt={18} gap={16}>
          <FeaturesHintWrapper
            dangerouslySetInnerHTML={{
              __html: t(strCode.START_ADDING_FEATURES_TITLE)
            }}></FeaturesHintWrapper>

          <CircleIconButton onClick={onModalOpen} tooltipLabel={t(strCode.ADD_FEATURE_TITLE)}>
            <SVG.PlusIcon />
          </CircleIconButton>
        </WrapperContainer>
      )}
    </>
  );
};

FeaturesList.propTypes = {
  onModalOpen: PropTypes.func.isRequired
};

export default FeaturesList;
